import { Box, TextProps } from "@chakra-ui/react";
import { validatePassword } from "@syla/shared/helpers/validatePassword";
import React from "react";

export const PasswordRequirementText =
  "Password must be at least 8 characters.";

export const validatePasswordInput = (password?: string): undefined | string =>
  validatePassword(password || "") ? undefined : PasswordRequirementText;

export function PasswordRequirements({
  ...props
}: TextProps): React.ReactElement {
  return (
    <Box fontSize="sm" {...props}>
      {PasswordRequirementText}
    </Box>
  );
}
